export const formatProfileFormInput = user => {
	return {
		defaultCall: user.defaultCall,
		// backend uses 'se' code for Swedish, front uses 'sv'
		language: user.language === 'se' ? 'sv' : user.language,
	};
};

const compareIsoDates = (left, right) => {
	if (!left && !right) return 0;
	if (!left) return 1;
	if (!right) return -1;

	const leftTime = new Date(left).getTime();
	const rightTime = new Date(right).getTime();

	if (Number.isNaN(leftTime) && Number.isNaN(rightTime)) return 0;
	if (Number.isNaN(leftTime)) return 1;
	if (Number.isNaN(rightTime)) return -1;

	return rightTime - leftTime;
};

export const groupMcpConnections = tokens => {
	if (!Array.isArray(tokens)) {
		return [];
	}

	const grouped = new Map();

	tokens.forEach(token => {
		const clientId = token?.clientId ?? token?.client_id ?? token?.id;
		const groupKey = String(clientId);
		const title = token?.clientName || token?.client_name || `Client ${groupKey}`;
		const expiresAt = token?.expiresAt || token?.expires_at || null;

		if (!grouped.has(groupKey)) {
			grouped.set(groupKey, {
				clientId: groupKey,
				clientName: title,
				latestExpiresAt: expiresAt,
				tokenIds: [],
				tokens: [],
			});
		}

		const group = grouped.get(groupKey);
		group.tokenIds.push(token.id);
		group.tokens.push(token);

		if (compareIsoDates(group.latestExpiresAt, expiresAt) > 0) {
			group.latestExpiresAt = expiresAt;
		}
	});

	return Array.from(grouped.values())
		.map(group => ({
			...group,
			tokenCount: group.tokenIds.length,
		}))
		.sort((left, right) => {
			const dateCompare = compareIsoDates(left.latestExpiresAt, right.latestExpiresAt);
			if (dateCompare !== 0) return dateCompare;
			return left.clientName.localeCompare(right.clientName);
		});
};

export const formatProfileFormOutput = form => {
	return {
		defaultCall: form.defaultCall,
		// backend uses 'se' code for Swedish, front uses 'sv'
		language: form.language === 'sv' ? 'se' : form.language,
		password: form.password,
	};
};
